const map = new WeakMap<any, any>()
let count = 1
const getRanNum = function(){
    var result = [];
   for(var i=0;i<1;i++){
     var ranNum = Math.ceil(Math.random() * 25);
       result.push(String.fromCharCode(65+ranNum));
   }
   return  result.join('');
 }
export const objectCountUtils = {
    getObjectCount(target:any){
        if(map.has(target)){
            return map.get(target)
        }
        const id = `ID[${++count}]`;
        // (target as any).___global___id___ = id;
        map.set(target, id);
        return id;
    },
    removeObjectCount(target:any){
        if(map.has(target)){
            map.delete(target)
            count--
        }
    },
    setObjectCount(target:any, id:any, key?:any){
        map.set(target, id);
        // (target as any)[key || '___global___id___'] = id
        return id
    },
    getNewCountId(){
        return ++count
    }
}

